import React from 'react'
import { formatDateSlash } from 'helpers/datetime'

function DateCell({ value }) {
  return (
    <td className="align-middle text-muted fw-light">
      {formatDateSlash(value)}
    </td>
  )
}

export default DateCell
